import { Controller } from "@hotwired/stimulus"
import { debugLog } from "../utils"

export default class PwaOpenerController extends Controller {
  static targets = ["installLink"]

  connect() {
    const platform = this.detectPlatform()
    const isPWA = this.isPWAInstalled()

    debugLog(`Platform: ${platform}`)
    debugLog(`Is PWA Installed: ${isPWA}`)

    if (isPWA || platform === "other") {
      this.element.classList.add("hidden")
      return
    }

    if (this.hasInstallLinkTarget) {
      this.addPlatformParam(platform)
    }
  }

  detectPlatform() {
    const ua = navigator.userAgent.toLowerCase()
    if (/android/.test(ua)) return "android"
    if (/iphone|ipad|ipod/.test(ua)) return "ios"
    return "other" // desktop, Mac, Windows, Linux, itd.
  }

  isPWAInstalled() {
    // iOS PWA check
    if (window.navigator.standalone === true) return true
    // Android / Chrome PWA check
    if (window.matchMedia("(display-mode: standalone)").matches) return true
    return false
  }

  addPlatformParam(platform) {
    if (platform === "other") return

    const link = this.installLinkTarget
    const url = new URL(link.href, window.location.origin)

    if (!url.searchParams.has("platform")) {
      url.searchParams.set("platform", platform)
      link.href = url.toString()
      debugLog(`Updated href → ${link.href}`)
    }
  }
}
